<template>
  <div class="notice-view-container">
    <p class="tit" v-if="param.release_status !== 2">预览</p>

    <!-- 更新弹窗 -->
    <div class="notice-view-update-wrap" v-if="isUpdate">
      <img src="image/img_update.png" alt="">
      <div class="notice-view-update">
        <p class="title" :class="{ 'has-href': titleHref }">{{ title }}</p>
        <div class="content" v-html="contentHtml">

        </div>

        <div class="btn-wrap">
          <wf-button type="primary">我知道了</wf-button>
        </div>
      </div>
    </div>

    <!-- 通知弹窗 -->
    <div class="notice-view-notice-wrap" v-if="!isUpdate">
      <div class="notice-view-notice">
        <p class="title">{{ title }}</p>
        <div class="content" v-html="contentHtml">

        </div>
        <div class="btn-wrap">
          <wf-button type="primary">确定</wf-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { createEditor } from '@wangeditor/editor'
export default {
  props: {
    mode: {
      // 弹窗模式，update为更新弹窗；notice为通知弹窗
      type: String,
      default: 'update'
    },
    param: {
      // 弹窗内容
      type: Object,
      default: () => {
        return {}
      }
    },
    titleHref: {
      // 更新弹窗的标题带的链接
      type: String,
      default: ''
    }
  },
  computed: {
    // 是否为更新弹窗
    isUpdate() {
      return this.mode === 'update'
    }
  },
  watch: {
    param: {
      handler(newObj, oldObj) {
        this.title = newObj.title
        if (newObj.notification_content && ~newObj.notification_content.indexOf('"type":')) {
          // 将编辑器格式的文本转换为html
          this.contentHtml = createEditor({ content: JSON.parse(newObj.notification_content) }).getHtml()
        } else {
          this.contentHtml = newObj.notification_content
        }
      },
      deep: true
    }
  },
  data() {
    return {
      title: '',
      contentHtml: '', // 正文内容，格式为html
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.notice-view-container {
  .tit {
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    margin-bottom: 8px;
  }
  .notice-view-update-wrap {
    width: 100%;
    position: relative;
    img {
      display: block;
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 9;
    }
  }
  .notice-view-update,
  .notice-view-notice-wrap {
    width: 100%;
    border-radius: 8px;
    box-shadow: 0px 4px 16px 0px rgba(13, 31, 60, .16);
    padding-bottom: 24px;
    box-sizing: border-box;
    .title {
      width: 100%;
      height: 44px;
      padding: 0 24px;
      box-sizing: border-box;
      font-size: 24px;
      font-weight: 500;
      line-height: 44px;
      text-align: center;
    }
    .content {
      width: 100%;
      min-height: 32px;
      max-height: 500px;
      overflow-y: scroll;
      padding: 4px 24px 10px;
      box-sizing: border-box;
      margin: 16px 0;
    }
    .btn-wrap {
      width: 100%;
      display: flex;
      justify-content: center;
      .wf-button {
        width: 108px;
      }
    }
    &.notice-view-update {
      min-height: 272px;
      position: absolute;
      left: 0;
      top: 57px;
      z-index: 8;
      padding-top: 108px;
      .title {
        text-align: center;
        &.has-href {
          cursor: pointer;
          &:hover {
            color: #2682FF;
          }
        }
      }
    }
    &.notice-view-notice-wrap  {
      min-height: 204px;
      margin-top: 18px;
      padding-top: 24px;
      .title {
        text-align: left;
      }
      .content {
        margin: 24px 0;
      }
      .btn-wrap {
        justify-content: flex-end;
        padding-right: 21px;
        box-sizing: border-box;
        .wf-button {
          width: 60px;
          padding: 0;
        }
      }
    }
  }
}
</style>
